// DEPENDENCIES
import axios from 'axios';
import env from './js/env';

const instance = axios.create({
    baseURL: env.BASE_URL
});

export default instance;
